 <div class="calendario-hora">
   <div class="elegir-dia-hora">
     <span [class.selected]="modalidadFiltro === ModalidadFiltroCalendarioHora.Calendario" (click)="elegirDiaHora(ModalidadFiltroCalendarioHora.Calendario)">Días</span>
     <span [class.selected]="modalidadFiltro === ModalidadFiltroCalendarioHora.Hora" (click)="elegirDiaHora(ModalidadFiltroCalendarioHora.Hora)">Horas</span>
   </div>
  <div class="calendar" *ngIf="modalidadFiltro === ModalidadFiltroCalendarioHora.Calendario" >
      <div class="header_calendar">
        <mat-icon (click)="lastMonth()">play_arrow</mat-icon>
        <span class="name_date"> {{ month_name_selected.locale(false).format('MMMM') }} {{ year_name_selected.format('YYYY') }}</span>
        <mat-icon (click)="nextMonth()">play_arrow</mat-icon>
      </div>
      <div class="container_name_days">
        <span class="name_day">Do</span>
        <span class="name_day">Lu</span>
        <span class="name_day">Ma</span>
        <span class="name_day">Mi</span>
        <span class="name_day">Ju</span>
        <span class="name_day">Vi</span>
        <span class="name_day">Sa</span>
      </div>
      <div class="container_days" #container_days>
        <div class="week" *ngFor="let week of mesActual">
          <ng-container *ngFor="let day of week.semana">
            <div class="day" *ngIf="day._isAMomentObject" (click)="elegirDia(day)"
              [ngClass]="{'selected': esElDiaActual(day)}">
              {{ day.date() }}
            </div>
            <span *ngIf="!day._isAMomentObject">
            </span>
          </ng-container>
        </div>
      </div>
  </div>
  <div class="contenedor-horas" *ngIf="modalidadFiltro === ModalidadFiltroCalendarioHora.Hora">
    <div class="hora" [class.selected]="hora === horaElegida" (click)="elegirHora(hora)" *ngFor="let hora of horas">
      {{hora}}
    </div>
  </div>
</div>
